import CombinedRevisionsModalContainer from 'ContentEditorUI/containers/CombinedRevisionsModalContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const PageThemeRevisionsModalContainer = () => {
  return /*#__PURE__*/_jsx(CombinedRevisionsModalContainer, {
    contentType: "page"
  });
};
export default PageThemeRevisionsModalContainer;